import { Directive, forwardRef } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, Validator } from '@angular/forms';

@Directive({
    selector: '[validateDecimal][formControlName],[validateDecimal][formControl],[validateDecimal][ngModel]',
    providers: [
        {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => DecimalValidatorDirective),
            multi: true,
        },
    ],
})
export class DecimalValidatorDirective implements Validator
{
    public validate(control: AbstractControl): { [key: string]: any } {
        if (control.value === null || control.value === '') {
            return null;
        }

        const regex = new RegExp(`^[-]?[0-9]+\.?([0-9]+)?$`);

        return regex.test(control.value)
                ? null
                : {decimal: true};
    }
}
